import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useStyledBlock, StyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";

type QuoteProps = { quote: string; attribution?: string };

export function QuoteBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<QuoteProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Quote</Label>
          <Textarea
            className="text-xs"
            rows={3}
            value={props.quote ?? ""}
            onChange={(e) => setProp((p) => { p.quote = e.target.value; })}
          />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Attribution</Label>
          <Input
            className="h-8 text-xs"
            value={props.attribution ?? ""}
            onChange={(e) => setProp((p) => { p.attribution = e.target.value; })}
          />
        </div>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} showTypography />;
  }
  return null;
}
